// extracted by mini-css-extract-plugin
export default {"satisfactionBarChartCont":"satisfactionBarChartCont_SatisfactionBarChart-module_pMZiC"};